import React from "react";
import useCountdown from "./useCountdown";

// docs/specs/login-setup.md §2: what the setup steps are, where the user is, and how long is left.
const SetupHeader = ({ stepLabel, expiresAt }) => {
  const seconds = useCountdown(expiresAt);
  const minutes = Math.ceil(seconds / 60);
  return (
    <div className="mfa-setup-header mb-3">
      <h4 className="mb-1">Finish setting up your account</h4>
      {stepLabel && <p className="text-muted small mb-1">{stepLabel}</p>}
      {minutes > 0 && (
        <p className="text-muted small mb-0">Finish within {minutes} {minutes === 1 ? "minute" : "minutes"}.</p>
      )}
    </div>
  );
};

export default SetupHeader;
